import { defineMessages } from 'react-intl'

const scope = 'app.containers.NotFoundPage'

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'This is the NotFoundPage container!',
  },
})
